import { Button, Col, Container, Row, Stack } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { useLink } from "@/hooks/useLink";
import clsx from "classnames";
import classes from "./styles.module.scss";
import Logo from "@/assets/LogoDarkEN.svg";

/**
 * Related-insights rail shown beneath an article.
 *
 * `related` is selected in `getStaticProps` rather than here: resolving it at render time
 * meant the whole of `insights.json` — every article body — shipped to the browser on
 * every insight page.
 *
 * @param {Object} props
 * @returns {JSX.Element}
 */
export const InsightPageRelatedSection = ({ className, item, related }) => {
  const locale = useLocale();
  const link = useLink();
  const items = related;

  return (
    <aside className={className}>
      <Container>
        <DynamicText path={`page.insight.related.title.${locale}`} tag="div" className="h3 mb-4" />
        <Row>
          {items.map((i) => {
            const href = link(
              `blog.item`,
              locale === "nl" && "url_nl" in i && i["url_nl"].length > 0 ? i["url_nl"] : i.url_slug
            );

            return (
              <Col xs={12} key={i.id}>
                <Stack className={clsx(classes.item, "py-3 px-4 ps-md-0 mb-4")}>
                  <a className={classes.img} href={href}>
                    {item.image ? (
                      <img src={i.image} alt="" />
                    ) : (
                      <div className="ratio ratio-1x1 bg-white border">
                        <div className="d-flex align-items-center p-3">
                          <Logo className="w-100" />
                        </div>
                      </div>
                    )}
                  </a>
                  <div className="h5 flex-grow-1" dangerouslySetInnerHTML={{ __html: i[`title_${locale}`] }} />
                  <Button variant="outline-primary" href={href} className="text-nowrap">
                    <DynamicText path={`blog.card.button.${locale}`} />
                  </Button>
                </Stack>
              </Col>
            );
          })}
        </Row>
      </Container>
    </aside>
  );
};

InsightPageRelatedSection.defaultProps = {
  className: "py-4 mb-md-5",
  related: [],
};
